import { render, staticRenderFns } from "./contactTransfer.vue?vue&type=template&id=3c653a94&scoped=true"
import script from "./contactTransfer.vue?vue&type=script&lang=js"
export * from "./contactTransfer.vue?vue&type=script&lang=js"
import style0 from "./contactTransfer.vue?vue&type=style&index=0&id=3c653a94&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c653a94",
  null
  
)

export default component.exports